// import { getCookie } from './Cookies';
import { getLocalStorageItem } from './LocalStorage';

/**
 * Handle the jwt token to decode the data function
 * @param {any} token - The token to decode
 * @returns {any} The decoded data, or null on error
 */
export const decodeJWT = (token: string) => {
  try {
    const base64Url = token.split('.')[1]; // Get the payload part
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/'); // Adjust for Base64 decoding
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
        // .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join(''),
    );
    return JSON.parse(jsonPayload); // Parse JSON
  } catch (error) {
    console.error('Invalid token', error);
    return null;
  }
};

/**
 * Handle the permission list view
 * @returns {any} The array of permission strings
 */
export const permissionList: () => string[] = () => {
  // const token = getCookie('ev-access-token');
  const token = getLocalStorageItem('ev-access-token');
  if (token) {
    return decodeJWT(token).permissions;
  }
  return [];
};

/**
 * Handle the account id
 * @returns {any} The account custom ID string
 */
export const getMyAccountCustomId: () => string = () => {
  // const token = getCookie('ev-access-token');
  const token = getLocalStorageItem('ev-access-token');
  if (token) {
    return decodeJWT(token).accountCustomId;
  }
  return '';
};

/**
 * Handle the check a permission function
 * @param {any} permission - The permission to check
 * @returns {any} True if the permission exists, false otherwise
 */
export const permissionCheck: (permission: string) => boolean = (permission: string) => {
  return permissionList()?.includes(permission);
};
/**
 * Handle the user type
 * @returns {any} The user type string
 */
export const getUserType = (): string => {
  // const token = getCookie('ev-access-token');
  const token = getLocalStorageItem('ev-access-token');

  if (token) {
    return decodeJWT(token).userType || '';
  }

  return '';
};

/**
 * Handle the platform permission list view
 * @returns {any} The array of platform permission strings
 */
export const platformPermissionList: () => string[] = () => {
  // const token = getCookie('ev-access-token');
  const token = getLocalStorageItem('ev-access-token');
  if (token) {
    return decodeJWT(token).platformPermissions || [];
  }
  return [];
};

/**
 * Handle the check a platform permission function
 * @param {any} permission - The platform permission to check
 * @returns {any} True if the platform permission exists, false otherwise
 */
export const platformPermissionCheck: (permission: string) => boolean = (permission: string) => {
  return platformPermissionList()?.includes(permission);
};

/**
 * Handle the check a platform permission function
 * @param {any} permission - The platform permission to check
 * @returns {any} True if the platform permission exists, false otherwise
 */
export const platformUserType: (permission: string) => boolean = (permission: string) => {
  return getUserType()?.includes(permission);
};
